export default "__VITE_ASSET__BM75yc0___"